
export default function (Component) {
  Component.options.__source = "src/components/Flowable/addNode.vue"
}
